import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import {withRouter} from 'react-router'
import config from '../../../config'

const FACEBOOK_LINK = config.FACEBOOK_LINK
const INSTAGRAM_LINK = config.INSTAGRAM_LINK
const LINKEDIN_LINK = config.LINKEDIN_LINK

const styles = theme => ({
  top: {
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    maxWidth: 1140,
    margin: 'auto',
  },
  topItem: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 180,
    margin: '10px 0',
    textDecoration: 'none',
  },
  topItemAnchor: {
    display: 'flex',
  },
  topItemIcon: {
    maxWidth: 28,
    maxHeight: 28,
    marginRight: 5,
    marginLeft: 10,
    '@media (min-width: 992px)': {
      marginLeft: 0,
      marginRight: 15,
    },
  },
  topItemImg: {
    objectFit: 'contain',
    maxWidth: '100%',
  },
  topItemText: {
    color: 'white',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif',
  },
  social: {
    maxWidth: 22,
  },
  body: {
    padding: 20,
  },
  bodyContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    maxWidth: 1140,
    margin: 'auto',
  },
  bodyItem: {
    minWidth: '100%',
    padding: '0 5px',
    textAlign: 'center',
    color: '#0f0f0f',
    fontSize: 15,
    fontWeight: 500,
    fontFamily: 'Roboto, sans-serif',
    textDecoration: 'none',
    '@media (min-width: 500px)': {
      minWidth: 'unset',
    },
  },
  space: {
    width: '100%',
    padding: '20px 0',
  },
  line: {
    width: 130,
    margin: '0 auto',
    height: 3,
    backgroundColor: '#e0e0e0',
    borderRadius: 2,
  },
  logoContainer: {
    width: '100%',
    textAlign: 'center',
    padding: '20px 0',
  },
  logo: {
    width: 300,
  },
  slogan: {
    paddingTop: 15,
    color: '#505050',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif',
  },
  bottom: {
    textAlign: 'center',
    padding: 20,
  },
  bottomLabel: {
    color: theme.palette.primary.main,
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif',
  },
  bottomDescription: {
    color: '#949494',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif',
  },
})

class Contact extends React.Component {

  static displayName = 'Contact.component'

  goTo = (url) => () => this.props.history.push(url)

  render() {
    const {classes} = this.props
    return (
      <footer>
        <div className={classes.top}>
          <div className={classes.topContainer}>
            <a className={classes.topItem} href="tel:+541152635754" target="_blank">
              <img className={classes.topItemIcon} src="/assets/icons/phone.png" alt="-"/>
              <div className={classes.topItemText}>(011) 5263-5754</div>
            </a>
            <a className={classes.topItem} href="mailto:hola@space.guru" target="_blank">
              <img className={classes.topItemIcon} src="/assets/icons/email.png" alt="-"/>
              <div className={classes.topItemText}>hola@space.guru</div>
            </a>
            <a className={classes.topItem} href="https://wa.me/541162220115" target="_blank">
              <img className={classes.topItemIcon} src="/assets/icons/whatsapp.png" alt="-"/>
              <div className={classes.topItemText}>+54 11 6222-0115</div>
            </a>
            <div className={classes.topItem}>
              <a className={`${classes.topItemAnchor} ${classes.topItemIcon} ${classes.social}`}
                 href={FACEBOOK_LINK} target="_blank">
                <img className={classes.topItemImg} src="/assets/icons/facebook.png" alt="-"/>
              </a>
              <a className={`${classes.topItemAnchor} ${classes.topItemIcon} ${classes.social}`}
                 href={LINKEDIN_LINK} target="_blank">
                <img className={classes.topItemImg} src="/assets/icons/linkedin.png" alt="-"/>
              </a>
              <a className={`${classes.topItemAnchor} ${classes.topItemIcon} ${classes.social}`}
                 href={INSTAGRAM_LINK} target="_blank">
                <img className={classes.topItemImg} src="/assets/icons/instagram.png" alt="-"/>
              </a>
            </div>
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.bodyContainer}>
            <a className={classes.bodyItem} href="https://space.guru/nosotros.html">Nosotros</a>
            <a className={classes.bodyItem} href="https://app.space.guru/ayuda">Centro de ayuda</a>
            <a className={classes.bodyItem} href="https://space.guru/proteccion.html">Programa de protección</a>
            <a className={classes.bodyItem} href="https://comunidad.space.guru" target="_blank">Blog</a>
            <a className={classes.bodyItem} href="https://space.guru/terminos.html">Términos y condiciones</a>
            <a className={classes.bodyItem} href="https://space.guru/privacidad.html">Políticas de privacidad y
              seguridad</a>
            <a className={classes.bodyItem} href="https://space.guru/almacenaje.html">Guía de almacenamiento</a>
          </div>
        </div>
        <div className={classes.space}>
          <div className={classes.line}/>
        </div>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src="/assets/logo/2.png" alt="logo"/>
          <div className={classes.slogan}>Somos Tu Baulera Inteligente</div>
        </div>
        <div className={classes.bottom}>
          <p>
            <span className={classes.bottomLabel}>Atención al cliente:&nbsp;</span>
            <span className={classes.bottomDescription}>Lunes a Viernes de 9:00 a 19:00 hs</span>
          </p>
        </div>
      </footer>
    )
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}))(withRouter(Contact))

const Link = ({text, className, onClick = () => {}}) => (
  <Typography
    variant={'subheading'}
    color={'primary'}
    className={className}
    onClick={onClick}
    style={{cursor: 'pointer'}}
  >
    {text}
  </Typography>
)



// WEBPACK FOOTER //
// ./src/sections/footer/components/footer.js